import React from 'react';

/**
 * AiSummaryLoadingSkeleton Component
 * Elegant pulsing skeleton placeholders matching the exact height and layout of summary statements.
 */
export default function AiSummaryLoadingSkeleton() {
    return (
        <div className="py-4 space-y-3.5 animate-pulse">
            {[1, 2, 3, 4].map((idx) => (
                <div key={idx} className="flex items-start gap-2.5">
                    {/* Pulsing Dot */}
                    <div className="w-1.5 h-1.5 rounded-full bg-blue-300 dark:bg-blue-700 mt-2 flex-shrink-0" />
                    {/* Badge & Line Skeletons */}
                    <div className="flex-1 space-y-1.5">
                        <div className="flex items-center gap-2">
                            <div className="h-5 w-32 bg-blue-200/70 dark:bg-blue-900/40 rounded" />
                            <div className="h-3.5 w-3/4 bg-slate-200 dark:bg-slate-700/50 rounded" />
                        </div>
                        <div className="h-3.5 w-5/6 bg-slate-100 dark:bg-slate-800 rounded" />
                    </div>
                </div>
            ))}
            <div className="pt-2 flex items-center justify-between">
                <div className="h-7 w-32 bg-blue-200/60 dark:bg-blue-900/40 rounded-xl" />
                <div className="h-4 w-24 bg-slate-200 dark:bg-slate-700 rounded" />
            </div>
        </div>
    );
}
